import { render, staticRenderFns } from "./UcContractCompanyCard.yaml?vue&type=template&id=741bc303&component"
import script from "./UcContractCompanyCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractCompanyCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports